import {AsyncState} from "../asyncState";
import {createSlice} from "@reduxjs/toolkit";
import {fetchAppInfo, fetchOrderInfo} from "./thunks";
import {AppInfo, OrderInfo} from "./types";

/**
 * info系のドキュメントを格納する
 * @field orderInfo users/{userId}/orders/info 内に格納されるデータ. ログインしているユーザーのinfoを格納する. ログインしていないまたは未フェッチの場合, undefinedとなる.
 * @field app info/app_info 内に格納されるデータ. 未フェッチの場合, undefinedとなる.
 */
export type InfoState = {
    orderInfo: AsyncState<OrderInfo | undefined>,
    appInfo: AsyncState<AppInfo | undefined>,
};

const infoSlice = createSlice({
    name: 'info',
    initialState: {
        orderInfo: {
            status: "idle",
            data: undefined,
            error: "",
        },
        appInfo: {
            status: "idle",
            data: undefined,
            error: "",
        }
    } as InfoState,
    reducers: {
        // orderInfoAdded(state, action: PayloadAction<{orderInfo: OrderInfo}>) {
        //     const {orderInfo} = action.payload;
        //     state.orderInfo.data = orderInfo;
        // }
    },
    extraReducers: builder => {
        builder.addCase(fetchOrderInfo.fulfilled, (state, action) => {
            state.orderInfo.data = action.payload.orderInfo;
            state.orderInfo.status = "succeeded"
        }).addCase(fetchOrderInfo.rejected, (state, action) => {
            state.orderInfo.error = action.error.message;
            state.orderInfo.status = "failed"
        })

        builder
          .addCase(fetchAppInfo.pending, (state) => {
            state.appInfo.status = "loading";
          })
          .addCase(fetchAppInfo.fulfilled, (state, action) => {
              state.appInfo.data = action.payload.appInfo;
              state.appInfo.status = "succeeded"
          }).addCase(fetchAppInfo.rejected, (state, action) => {
            state.appInfo.error = action.error.message;
            state.appInfo.status = "failed"
        })
    }
});


const infoReducer = infoSlice.reducer;
export default infoReducer;